/* eslint-disable no-unused-vars */
import { Grid } from '@mui/material'
import CellHOC from '@platform/react/hoc/list/cell'
import Icon from 'ui/Element/Icon'

const styles = () => ({
  icon: {
    width: '3rem',
    minHeight: '3rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
})

/**
 * Intended to display an icon for the organisation.
 *
 * @param {Object} classes  styling for the cell
 * @param {Object} props    props for the cell
 *
 * @returns {JSX.Element}
 */
export const ListItemCellOrganisationIcon = (classes, { type: typeKey, events }) => {
  const [type] = events?.getOrganisationType?.(typeKey) || []
  const icon = type?.icon || 'help'

  return (
    <Grid className={classes.icon}>
      <Icon
        size={'1.5rem'}
        shape={'circle'}
        source={icon}
        color={'black.main'}
        background={'gray.960'}
      />
    </Grid>
  )
}

export default CellHOC(ListItemCellOrganisationIcon, styles)
